import Container, { ContainerProps } from 'app/components/base/Container'

interface Props {
  sx?: ContainerProps['sx']
}

const CategoryViewContainer: RFC<Props> = ({ sx, children }) => {
  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, md: '45px' }, ...sx }}>
      {children}
    </Container>
  )
}

export default CategoryViewContainer
